import React, { useEffect, useState } from "react";
import { Col, Row, Input, Button, Divider, Typography, Spin } from "antd";
import { BsStars } from "react-icons/bs";

import { FaArrowsAltH } from "react-icons/fa";
import {  IoMdRefresh } from "react-icons/io";
import { CgArrowsExpandRight } from "react-icons/cg";
import { TbShirt } from "react-icons/tb";

import "./generateScriptWIthAI.css";
import { LuPencilLine } from "react-icons/lu";
import { PiShirtFoldedDuotone } from "react-icons/pi";
import { ModalWrapper } from "../videos/styled";
import script from "../../../../services/script";
import { CustomButton, CustomSecondaryButton } from "../../physician_page/styled";

const GenereateScriptWithAi = ({
  open,
  setOpen,
  AiScriptUse,
}) => {
  const [aiResponse, setAIResponse] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [searchedLibraryText,setSearchedLibraryText] = useState('')
  const [hovered, setHovered] = useState({
    Description: null,
    Impact: null,
    Reference: null,
    Remediation: null,
  });



  const librarySuggestion = async () => {
    try {
      setIsLoading(true);
      const res = await script.generateScriptWithAi({
        searchText: searchedLibraryText
          ? searchedLibraryText
          : "network payload",
      });
      setAIResponse(res?.data?.data);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };

  const optimizeLibrarySuggestion = async (keyword, field) => {
    try {
      setIsLoading(true);
      const res = await script.optimizeScriptWithAi ({
        keyword: keyword,
        field: field.toLowerCase(),
        data: aiResponse[field.toLowerCase()],
      });
      setAIResponse((prev) => ({
        ...prev,
        [field.toLowerCase()]: res?.data?.details,
      }));
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (searchedLibraryText?.length) librarySuggestion();
  }, []);

  const iconActions = [
    { icon: <IoMdRefresh size={15} />, label: "Retry", keyword: "retry" },
    { icon: <LuPencilLine size={15} />, label: "Rephrase", keyword: "rephrase" },
    { icon: <FaArrowsAltH size={15} />, label: "Shorten", keyword: "shorten" },
    { icon: <CgArrowsExpandRight size={15} />, label: "Expand", keyword: "expand" },
    { icon: <TbShirt size={15} />, label: "More Casual", keyword: "more-casual" },
    {
      icon: <PiShirtFoldedDuotone size={15} />,
      label: "More Formal",
      keyword: "more-formal",
    },
  ];


    const handleCancel = () => {
    setOpen(false)
  };
  return (
    <ModalWrapper
      footer={null}
      open={open}
      width={700}
      onCancel={handleCancel}
      title={"Generate AI Script"}
    >
      <Spin spinning={isLoading}>
        <>
          <Row justify="center" style={{ marginBottom: 20 }}>
            <Col span={22} className="d-flex justify-content-center">
              <Input
                placeholder="Search..."
                onChange={(e) => setSearchedLibraryText(e.target.value)}
                enterButton
                defaultValue={searchedLibraryText}
              />
              <CustomButton
                disabled={searchedLibraryText?.length === 0}
                style={{marginLeft:"10px"}}
                type="primary"
                onClick={() => librarySuggestion()}
                icon={<BsStars style={{ marginRight: "3px" }} />}
              >
                Generate Script
              </CustomButton>
            </Col>
          </Row>

          <Divider style={{ backgroundColor: "var(--text-secondary)" }} />

            <Row gutter={[0, 16]}>
              {["Title", "Description"].map(
                (field) => (
                  <Col span={20} offset={2} key={field}>
                    <div className="d-flex justify-content-between">
                      <Typography.Text
                        style={{ color: "var(--text-primary)" }}
                        strong
                      >
                        {field}:
                      </Typography.Text>
                      {aiResponse[field.toLowerCase()]?.length && (
                        <div className="icon-container">
                          {iconActions.map((action, index) => (
                            <div
                              key={index}
                              onMouseEnter={() =>
                                setHovered((prev) => ({
                                  ...prev,
                                  [field]: index,
                                }))
                              }
                              onMouseLeave={() =>
                                setHovered((prev) => ({
                                  ...prev,
                                  [field]: null,
                                }))
                              }
                              onClick={() =>
                                optimizeLibrarySuggestion(action.keyword, field)
                              }
                              className={
                                hovered[field] === index ? "hovered" : "icon"
                              }
                              style={{ cursor: "pointer" }}
                            >
                              {hovered[field] === index ? (
                                <div className={`expand-button expanded`}>
                                  <span className="expand-button-icon">
                                    {action.icon}
                                  </span>
                                  {action.label}
                                </div>
                              ) : (
                                <div
                                  style={{ color: "var(--individual-button)" }}
                                >
                                  {action.icon}
                                </div>
                              )}
                            </div>
                          ))}
                        </div>
                      )}
                    </div>

                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        marginBottom: 10,
                      }}
                    >
                      <Input.TextArea
                        autoSize={{ minRows:field==="Title" ?1: 2, maxRows: field==="Title" ? 1:8 }}
                        placeholder={field}
                        style={{
                          background: "var(--dashboard-primay)",
                          border: "none",
                          flex: 1,
                        }}
                        readOnly
                        value={aiResponse[field.toLowerCase()]}
                      />
                    </div>
                  </Col>
                )
              )}
            </Row>

          <Row justify="center" gutter={16} style={{ marginTop: 20 }}>
            <Col>
              <CustomSecondaryButton
                type="default"
                onClick={() => {
                  setOpen(false);
                  setSearchedLibraryText("");
                }}
              >
                Cancel
              </CustomSecondaryButton>
            </Col>
            <Col>
              <CustomButton
                type="primary"
                onClick={() => {
                  AiScriptUse(aiResponse);
                  setSearchedLibraryText("");
                  setOpen(false);
                }}
              >
                Use Script
              </CustomButton>
            </Col>
          </Row>
        </>
      </Spin>
    </ModalWrapper>
  );
};

export default GenereateScriptWithAi;
